const initialState = {
    schema: [
        {
            isFormVisible: true,
            isFormDisabled: false,
            isFormCompleted: false,
            vehicleSelected: null,
            dataSelected: null,
            vehicleDetails: null,
            bestFinancingLine: {loading: false, error: false, data: null},
            reloadAt: null
        },
        {
            isFormVisible: false,
            isFormDisabled: true,
            isFormCompleted: false,
            vehicleSelected: null,
            dataSelected: null,
            vehicleDetails: null,
            bestFinancingLine: {loading: false, error: false, data: null},
            reloadAt: null
        },
        {
            isFormVisible: false,
            isFormDisabled: true,
            isFormCompleted: false,
            vehicleSelected: null,
            dataSelected: null,
            vehicleDetails: null,
            bestFinancingLine: {loading: false, error: false, data: null},
            reloadAt: null
        }
    ],
    technicalSpecs:[],
    brands: null,
    models: null,
    years: null,
    versions: null,
    showBflSection: false,
    deleteButtonEnabled: true,
    cardIndexMobile: 0,
    openModalForm: false
}

export default initialState
